/**
 * Lazy KaTeX loader — nur bei Bedarf importieren (Bundle-Splitting).
 *
 * Importer ist injizierbar für Tests (analog zu lib/mermaid/loader.ts);
 * der Default lädt Paket + Stylesheet als eigenen Vite-Chunk.
 */
type KatexLike = {
  render: (
    tex: string,
    el: HTMLElement,
    opts?: { displayMode?: boolean; throwOnError?: boolean },
  ) => void;
};

let katexPromise: Promise<KatexLike> | null = null;

/** Standard-Importer: lädt `katex` lazy (CSS ist statisch in main.ts eingebunden). */
export function defaultKatexImporter(): Promise<{ default: KatexLike }> {
  return import('katex') as unknown as Promise<{ default: KatexLike }>;
}

let importer: () => Promise<{ default: KatexLike }> = defaultKatexImporter;

/** Test-Hook: eigenen Importer setzen (setzt den Cache zurück). */
export function setKatexImporter(fn: () => Promise<{ default: KatexLike }>): void {
  importer = fn;
  katexPromise = null;
}

export async function getKatex(): Promise<KatexLike> {
  if (!katexPromise) {
    katexPromise = importer().then((m) => m.default);
  }
  return katexPromise;
}
